import React from "react";

export default function Section4() {
  return (
    <div className="w-full Section3 px-5 md:px-0 pt-[2%]">
      <div className="flex flex-col items-center w-full md:flex-row justify-evenly section3-container">
        <div className="w-full md:w-[36%] text-[#373737]">
          <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
           Shopify Development Partner for Texas Businesses
          </h2>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            Mean3 delivers Shopify development services for Texas ecommerce brands, helping businesses streamline operations and manage daily workflows efficiently while supporting long-term growth.
          </p>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
           We design stores that align with your brand identity and provide intuitive navigation, clear layouts, and smooth integrations with business tools, ensuring a seamless experience for both your team and customers.
          </p>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
           Our team also handles platform migrations from Magento, WooCommerce, or BigCommerce, minimizing downtime and maintaining data integrity. Post-launch, we provide ongoing technical support and updates to help Texas businesses sustain reliable performance and customer satisfaction.
          </p>
          <a
              href="https://mean3.com/contact-mean3"
              className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
            >
              Get a Free Quote
            </a>
        </div>

        <div className="w-full md:w-auto">
          <img
            src="../../../assets/computer-shopify.png"
            alt="Computer Logo"
            className="w-full md:w-auto cover"
          />
        </div>
      </div>
      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
